import ServiceDetail from "@/components/ServiceDetail";
import { SERVICES_DATA } from "@/data/services";
import { GALLERY_ITEMS } from "@/data/gallery";

export default function Landscaping() {
    const projects = GALLERY_ITEMS.filter((g) => g.category === "landscaping");
    return <ServiceDetail data={SERVICES_DATA.landscaping} projects={projects} />;
}
